export default __webpack_public_path__ + "static/media/right_sura.f7370eeb.svg";